import { ToastContext } from '@/components/Toast';
import type { ToastContextValue } from '@/components/Toast/ToastContext';
import { useContext } from 'react';

// TODO this is a bit of a hack because for some reason server components (e.g. ClientList) is being rendered before ToastProvider
const noop = (): void => {};
const noopToast: ToastContextValue = () => ({
  success: noop,
  error: noop,
  warning: noop,
  info: noop
});
export const useToast = () => {
  const context = useContext(ToastContext);
  return context ?? noopToast;
};